import { LoginService } from 'src/app/core/services/login.service';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { switchMap } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { GetSecondHandSuppliesBidsService } from '../../services/get-second-hand-supplies-bids.service';
import { PageEvent } from '@angular/material/paginator';
import { LoginData } from 'src/app/core/models/login-data';
@Component({
  selector: 'app-my-bids',
  templateUrl: './my-bids.component.html',
  styleUrls: ['./my-bids.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class MyBidsComponent implements OnInit {
  /* --------------------------------- Fields --------------------------------- */
  displayedColumns: string[] = ['sNo','title', 'bid_starts_at', 'bid_ends_at',  'sku', 'check_out', 'action'];
  dataSource: MatTableDataSource<any>;
  expandedElement: any | null;
  filterForm = this.fb.group({
    limit: [50, [Validators.required]],
    offset: [0, [Validators.required]]
  });
  filterSubject: BehaviorSubject<any>;
  totalElements = 0;
  loginData: LoginData;
  /* ------------------------------- Constructor ------------------------------ */
  constructor(
    private fb: FormBuilder,
    private getSecondHandSuppliesBidsService: GetSecondHandSuppliesBidsService,
    private router: Router,
    private loginService : LoginService) { }

  /* ---------------------------- Life cycle hooks ---------------------------- */
  ngOnInit(): void {
    this.loginData = this.loginService.getLoginData();
    this.filterSubject = new BehaviorSubject<any>(this.filterForm.value);
    this.filterSubject.pipe(switchMap(filter=>{
      this.dataSource = null;
      return this.getSecondHandSuppliesBidsService.getSecondHandSuppliesBids(filter);
    })).subscribe(([second_hand_supplies_bids, count]: any)=>{
      this.dataSource = new MatTableDataSource<any>(second_hand_supplies_bids);
      this.totalElements = count;
    })
  }


  /* --------------------------------- Getters -------------------------------- */
  get limit(){
    return this.filterForm.get('limit');
  }

  get offset(){
    return this.filterForm.get('offset');
  }
  changePage(e: PageEvent){
    this.offset.setValue(e.pageSize * e.pageIndex);
    this.filterSubject.next(this.filterForm.value);
  }
  checkout(e: any, id: string){
    e.stopPropagation();
    this.router.navigate(["/checkout/second-hand-payment", id]);
  }
}
